import { render, staticRenderFns } from "./ViewsEditModal.vue?vue&type=template&id=60e44b16&scoped=true"
import script from "./ViewsEditModal.vue?vue&type=script&lang=ts"
export * from "./ViewsEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e44b16",
  null
  
)

export default component.exports